const conceptCncpt = (() => {
  const pageConcept = (document.getElementById("pageConcept") != null);
  if (pageConcept) {



    // let sW = window.innerWidth;
    // let sH = window.innerHeight;


    let jsSecCncpt = document.querySelectorAll(".js-sec-cncpt")

    document.addEventListener("DOMContentLoaded", () => {

      jsSecCncpt.forEach(element => {

        let bgWrap = element.querySelector(".js-bg-wrap")

        ScrollTrigger.create({
          trigger: element,
          start: "0% 20%",
          toggleClass: { targets: bgWrap, className: "act" },
          once: true, // 着脱を繰り返したくない場合(一度だけclass付与)
          // markers: true,
        });

      });
    });



  }
})()
export default conceptCncpt;